/**
 * AuthRouteLayout - Picks layout for auth routes by viewport.
 * Mobile (≤768px): AuthLayout only (no shell/tabs). Desktop (>768px): OwnerLayout (unchanged).
 * Used for /login, /forgot-password, /owner/reset-password. Desktop behavior is unchanged.
 */

import AuthLayout from './AuthLayout.jsx';
import OwnerLayout from './OwnerLayout.jsx';
import { useViewport } from '../../contexts/ViewportContext.jsx';

export default function AuthRouteLayout({ children, owner = null, onLogout = null }) {
  const { isMobile } = useViewport();

  if (isMobile) {
    return <AuthLayout>{children}</AuthLayout>;
  }

  return (
    <OwnerLayout owner={owner} onLogout={onLogout}>
      {children}
    </OwnerLayout>
  );
}
